
/* System defined core library */
import { Component, NgModule, VERSION } from '@angular/core';
import { ProMapComponent } from './components/map/map.component';
import { BingMapComponent } from './components/bing-map/bing-map.component';
import { BingMapsService } from './services/bing-map.service';
import { MapUtilityService } from './services/map-utility.service';
import { WINDOW_PROVIDERS } from './services/window.service';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        BingMapComponent,
        ProMapComponent
    ],
    exports: [
        BingMapComponent,
        ProMapComponent
    ],
    providers: [
        BingMapsService,
        MapUtilityService,
        WINDOW_PROVIDERS
    ]
})
export class ProMapModule { }
